import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { Observable, of } from 'rxjs';
import { IInitialPageData } from '../shared/interface/general';
import get from 'lodash.get';

export interface IFooterContactInfoItem {
  header: string;
  address: string;
  address2: string;
  email: string;
  phone: string;
  cvrNumber: string;
  facebookPage: any;
  linkedInPage: any;
  youtubePage: any;
  cookiePolicyPageUrl?: string;
  reCaptchaSecret: string;
  textColor: string;
  buttonsColor: string;
  backgroundColor: string;
}

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  initialPageData: IInitialPageData | null = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);

  constructor(
    private http: HttpClient
  ) { }

  getFooter(): Observable<IFooterContactInfoItem>
  {
    if (this.initialPageData && this.initialPageData.footer) {
      return of(this.initialPageData.footer);
    }

    return this.http.get<IFooterContactInfoItem>(`/ubaseline/api/bgfooter/getFooter`);
  }
}
